import { COLORS } from '../utils/constants';
import convertToOption, {
  convertToEnumWithOptions,
} from '../utils/convert-to-option';

export const fullName = contact =>
  [contact.firstName, contact.lastName].filter(n => n).join(' ');

export const contactFilterFields = ['email', 'firstName', 'lastName'];

export const contactSelectLabel = contact =>
  `${fullName(contact)} - ${contact.email}`;

const ACTIVE = 'Active';
const INACTIVE = 'Inactive';
const UNSUBSCRIBED = 'Unsubscribed';
const SUBSCRIBED = 'Subscribed';

const CONTACT_STATUSES = { ACTIVE, INACTIVE, UNSUBSCRIBED };

export const contactStatusesEnum = convertToEnumWithOptions(CONTACT_STATUSES);

export const contactStatuses = [
  contactStatusesEnum.ACTIVE,
  contactStatusesEnum.INACTIVE,
  contactStatusesEnum.UNSUBSCRIBED,
];

export const alertSubscriptionStatuses = [SUBSCRIBED, UNSUBSCRIBED].map(
  convertToOption,
);

export const STATUS_COLOR_MAP = {
  [ACTIVE]: COLORS.SUCCESS,
  [INACTIVE]: COLORS.DANGER,
  [UNSUBSCRIBED]: COLORS.INFO,
};

export const selfServiceActivatedOptions = [
  {
    label: 'Yes',
    value: 'True',
  },
  {
    label: 'No',
    value: 'False',
  },
];
